export default __webpack_public_path__ + "392798357aa3a7e9a606acbbb92ce7af.svg";